module.exports = __webpack_public_path__ + "static/media/email-sent.cd6ee918.svg";